<mat-drawer-container class="example-container"
                      autosize
                      [hasBackdrop]="true">
  <mat-drawer #drawer
              mode="push">
    <div *ngIf="userData"
         class="mdc-drawer__header">
      <div class="drawer-user-identity">
        <div class="drawer-user-avatar"
             aria-hidden="true">
          {{ userData.userName?.split(' ')[0]?.charAt(0) | uppercase }}{{ userData.userName?.split(' ')[1]?.charAt(0) | uppercase }}
        </div>
        <div class="drawer-user-text">
          <div class="drawer-user-name">
            {{userData.userName}}
          </div>
          <div class="drawer-user-email">
            {{userData.userEmail}}
          </div>
        </div>
      </div>

      <div class="drawer-user-role-row">
        <span class="drawer-user-role-text">
          {{ userData.userDBRole === 'CLIENT_ADMIN' ? 'Facilitator' : userData.userDBRole }}
        </span>
        <span *ngIf="planLabel"
              [ngClass]="['plan-label', planLabel === 'Hub' ? 'plan-label--hub' : 'plan-label--spoke']">
          {{ planLabel }}
        </span>
        <button *ngIf="isOwnerRole()"
                class="edit-profile-btn"
                aria-label="Edit profile"
                matTooltip="Edit user"
                (click)="editProfile($event)">
          <mat-icon>
            manage_accounts
          </mat-icon>
        </button>
      </div>

      <div *ngIf="shouldDisplayFacilityName() && (facilityName || isOwnerAndNotSpoke())"
           class="facility-name-display">
        <mat-icon class="facility-icon">
          business
        </mat-icon>
        <span class="facility-name">
          {{facilityName}}
        </span>
        <button *ngIf="userData.userDBRole === UserRoles.owner"
                class="facility-setup-button small-button"
                aria-label="Open Facility Setup"
                mat-icon-button
                matTooltip="Facility Setup"
                (click)="openFacilitySetup($event)">
          <mat-icon>
            engineering
          </mat-icon>
        </button>
      </div>
    </div>

    <mat-accordion *ngIf="userData"
                   class="sidebar-menu-list">
      <div id="usersMenu"></div>

      <!-- Profile & Patient Management Section -->
      <div class="menu-section">
        <div class="menu-section-header">
          Profile & Patients
        </div>

        <mat-list-item *ngIf="userData.userDBRole === UserRoles.client && userData.userDBRole !== UserRoles.consultant"
                       [disabled]="!activateMenuItems"
                       (click)="openClient()">
          <a class="fx-row">
            <mat-icon aria-hidden="true">
              account_circle
            </mat-icon>
            <span>
              {{ myProfileLabel }}
            </span>
          </a>
        </mat-list-item>

        <mat-expansion-panel *ngIf="![UserRoles.superuser, UserRoles.client].includes(userData.userDBRole) && !ownerNeeded"
                             class="menu-group">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon aria-hidden="true">
                assignment_ind
              </mat-icon>
              <span>
                {{ clientMatterLabel }}
              </span>
              <mat-icon [ngClass]="hasNotifications() ? 'blinking-icon' : 'hidden'">
                notifications
              </mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="menu-group-compact">
            <mat-list-item [disabled]="true"
                           (click)="navigateToClient('employees')">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  badge
                </mat-icon>
                <span>
                  Employees
                </span>
              </a>
            </mat-list-item>
            <mat-list-item (click)="navigateToClient('external')">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  personal_injury
                </mat-icon>
                <span>
                  Facility Patients
                </span>
              </a>
            </mat-list-item>
          </div>
        </mat-expansion-panel>
      </div>

      <div *ngIf="userData.userDBRole !== UserRoles.consultant"
           class="divider"></div>

      <!-- User Management Section -->
      <div *ngIf="userData.userDBRole !== UserRoles.consultant"
           class="menu-section">
        <div class="menu-section-header">
          User Management
        </div>

        <div class="menu-group-compact">
          <!-- CREATE PATIENT PROFILE -->
          <mat-list-item *ngIf="(userPermissions && createuser) || canCreatePatient()"
                         [disabled]="!activateMenuItems"
                         (click)="navigateToCreateClientMatter()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                assignment_ind
              </mat-icon>
              <span>
                {{ createClientMatterLabel }}
              </span>
            </a>
          </mat-list-item>

          <mat-list-item *ngIf="canCreateFacilityUser()"
                         [disabled]="!activateMenuItems"
                         (click)="navigateToCreateAdminUser()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                person_add
              </mat-icon>
              <span>
                {{ createUserLabel }}
              </span>
            </a>
          </mat-list-item>
        </div>
      </div>

      <div *ngIf="userData.userDBRole !== UserRoles.consultant"
           class="divider"></div>

      <!-- Users & Management Section -->
      <div *ngIf="userData.userDBRole !== UserRoles.consultant"
           class="menu-section">
        <div class="menu-section-header">
          Users
        </div>

        <div class="menu-group-compact">
          <mat-list-item *ngIf="![UserRoles.superuser, UserRoles.client].includes(userData.userDBRole) && ownerNeeded"
                         [disabled]="!activateMenuItems"
                         (click)="navigateToAttorneysLawFirms()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                work
              </mat-icon>
              <span>
                {{ attorneysLabel }}
              </span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="userData.userDBRole === UserRoles.superuser"
                         id="reportGen"
                         [disabled]="!activateMenuItems"
                         (click)="navigateGenerateReport()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                insert_drive_file
              </mat-icon>
              <span>
                {{ reportLabel }}
              </span>
            </a>
          </mat-list-item>

          <mat-list-item *ngIf="userData.userDBRole === UserRoles.superuser"
                         [disabled]="!activateMenuItems"
                         (click)="createUser(UserRoles.owner)">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                person
              </mat-icon>
              <span>
                {{ ownerLabel }}
              </span>
            </a>
          </mat-list-item>
          <!-- <mat-list-item
            *ngIf="canManageUsers() && isNotSilver()"
            id="buttonSectionIdent"
            [disabled]="!activateMenuItems">
            <a  class="fx-row"(click)="navigateToClientUsers()">
              <mat-icon aria-hidden="true">person</mat-icon>
              <span>
                {{ clientUsersLabel }}
              </span>
            </a>
          </mat-list-item> -->
          <mat-list-item *ngIf="[UserRoles.superuser].includes(userData.userDBRole)"
                         [disabled]="!activateMenuItems"
                         (click)="navigateToOwner()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                person
              </mat-icon>
              <span>
                {{ ownerListLabel }}
              </span>
            </a>
          </mat-list-item>
        </div>

        <mat-expansion-panel *ngIf="canManageUsers()"
                             class="menu-group"
                             [disabled]="!activateMenuItems">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon aria-hidden="true">
                person
              </mat-icon>
              <span>
                {{ facilityListLabel }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="sub-items">
            <mat-list-item [disabled]="!activateMenuItems"
                           (click)="navigateToMedicalRecords()">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  medical_services
                </mat-icon>
                <span>
                  Facilitators
                </span>
              </a>
            </mat-list-item>
            <mat-list-item [disabled]="!activateMenuItems || checkIsSpoke()"
                           (click)="navigateToConsultants()">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  people
                </mat-icon>
                <span>
                  Consultants
                </span>
              </a>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-list-item *ngIf="canManageUsers()"
                       [disabled]="true"
                       (click)="navigateToAssociate()">
          <a class="fx-row">
            <mat-icon aria-hidden="true">
              person
            </mat-icon>
            <span>
              {{ associateListLabel }}
            </span>
          </a>
        </mat-list-item>
      </div>

      <div *ngIf="isOwnerAndNotSpoke() || userData.userDBRole === UserRoles.superuser"
           class="divider"></div>

      <!-- Facilities Section -->
      <div *ngIf="isOwnerAndNotSpoke() || userData.userDBRole === UserRoles.superuser"
           class="menu-section">
        <div class="menu-section-header">
          Facilities
        </div>

        <div class="menu-group-compact">
          <mat-list-item [disabled]="!activateMenuItems"
                         (click)="navigateToFacilities()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                business
              </mat-icon>
              <span>
                Facilities
              </span>
            </a>
          </mat-list-item>
          <!-- <mat-list-item
            [disabled]="!activateMenuItems">
            <a  class="fx-row"(click)="openCreateFacilityForm()">
              <i
                class="material-icons"
                aria-hidden="true">
                add_business
              </i>
              <span>
                Create facility
              </span>
            </a>
          </mat-list-item> -->
          <mat-expansion-panel class="menu-group"
                               [disabled]="!activateMenuItems">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon aria-hidden="true">
                  person
                </mat-icon>
                <span>
                  Facility users
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-nav-list class="sub-items">
              <mat-list-item [disabled]="!activateMenuItems"
                             (click)="navigateToMedicalRecords()">
                <a class="fx-row">
                  <mat-icon aria-hidden="true">
                    medical_services
                  </mat-icon>
                  <span>
                    Facilitators
                  </span>
                </a>
              </mat-list-item>
              <mat-list-item [disabled]="!activateMenuItems"
                             (click)="navigateToConsultants()">
                <a class="fx-row">
                  <mat-icon aria-hidden="true">
                    people
                  </mat-icon>
                  <span>
                    Consultants
                  </span>
                </a>
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Tools & Features Section -->
      <div class="menu-section">
        <div class="menu-section-header">
          Tools & Features
        </div>

        <mat-expansion-panel *ngIf="![UserRoles.superuser, UserRoles.client].includes(userData.userDBRole) && !ownerNeeded"
                             class="menu-group"
                             [disabled]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon aria-hidden="true">
                book
              </mat-icon>
              <span>
                Facility's library
              </span>
              <mat-icon [ngClass]="hasNotifications() ? 'blinking-icon' : 'hidden'">
                notifications
              </mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list class="sub-items">
            <mat-list-item *ngIf="isNotClientRole()"
                           [disabled]="true"
                           (click)="navigateToFeedLibrary()">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  description
                </mat-icon>
                <span>
                  {{ libraryLabel }}
                </span>
              </a>
            </mat-list-item>
            <mat-list-item *ngIf="isNotClientRole()"
                           [disabled]="true"
                           (click)="navigateToAddSources()">
              <a class="fx-row">
                <mat-icon aria-hidden="true">
                  language
                </mat-icon>
                <span>
                  {{ sourcesLabel }}
                </span>
              </a>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div *ngIf="userData.userDBRole !== UserRoles.consultant"
             class="menu-group-compact">
          <mat-list-item *ngIf="canUseVideoConferencing()"
                         [disabled]="true"
                         (click)="goToComingSoon('video-conferencing')">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                video_call
              </mat-icon>
              <span>
                {{ videoConferencingLabel }}
              </span>
            </a>
          </mat-list-item>
          <!-- <mat-list-item
            *ngIf="isOwnerRole() && userData.plancode !== 'platinumyearly' && !checkIsSpoke()"
            [disabled]="!activateMenuItems">
            <a  class="fx-row"(click)="goToComingSoon('plan-upgrade')">
              <i
                class="material-icons"
                aria-hidden="true">
                upgrade
              </i>
              <span>
                {{ upgradeYourPlanLabel }}
              </span>
            </a>
          </mat-list-item> -->
          <mat-list-item *ngIf="isOwnerAndSpoke()"
                         [disabled]="!activateMenuItems"
                         (click)="openJoinNuageDxNetwork()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                hub
              </mat-icon>
              <span>
                {{ joinNuageDxNetworkLabel }}
              </span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="isOwnerRole()"
                         [disabled]="!activateMenuItems"
                         (click)="openAuditLog()">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                timeline
              </mat-icon>
              <span>
                {{ auditLogLabel }}
              </span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="isOwnerRole() && !checkIsSpoke()"
                         [disabled]="!activateMenuItems"
                         routerLink="/hub/usage">
            <a class="fx-row">
              <mat-icon aria-hidden="true">
                bar_chart
              </mat-icon>
              <span>
                Usage
              </span>
            </a>
          </mat-list-item>
          <mat-list-item *ngIf="isOwnerRole() && !checkIsSpoke()"
                         [disabled]="!activateMenuItems"
                         routerLink="/hub/invitations">
            <a class="fx-row">
              <mat-icon aria-hidden="true">group_add</mat-icon>
              <span>Invitations</span>
            </a>
          </mat-list-item>
        </div>
      </div>

      <!-- Admin Section (Super User only) -->
      <div *ngIf="userData.userDBRole === UserRoles.superuser"
           class="menu-section">
        <div class="menu-section-header">
          Admin
        </div>
        <mat-list-item routerLink="/admin/network"
                       [disabled]="!activateMenuItems">
          <a class="fx-row">
            <mat-icon aria-hidden="true">
              hub
            </mat-icon>
            <span>
              Modalities &amp; Peers
            </span>
          </a>
        </mat-list-item>
        <mat-list-item routerLink="/admin/storage-report"
                       [disabled]="!activateMenuItems">
          <a class="fx-row">
            <mat-icon aria-hidden="true">
              bar_chart
            </mat-icon>
            <span>
              Storage Report
            </span>
          </a>
        </mat-list-item>
      </div>

      <!-- Logout Section -->
      <div class="logout-section menu-section">
        <mat-list-item (click)="auth_$.logout()">
          <a class="fx-row">
            <mat-icon aria-hidden="true">
              power_settings_new
            </mat-icon>
            <span>
              {{ logoutLabel }}
            </span>
          </a>
        </mat-list-item>
      </div>
      <div id="ze-snippet-container"></div>
    </mat-accordion>
  </mat-drawer>

  <mat-drawer-content>
    <header id="app-bar"
            [ngClass]="['mdc-top-app-bar', 'header-bar']">
      <div class="drawer mdc-top-app-bar__row">
        <section [ngClass]="['mdc-top-app-bar__section', 'mdc-top-app-bar__section--align-start']">
          <button *ngIf="userEnabled"

                  id="nuageMenu"
                  class="mdc-top-app-bar__navigation-icon"
                  mat-icon-button

                  [ngClass]="{ hidden: maintenance }"
                  (click)="drawer.toggle()">
            <span class="material-icons menu">
              menu
            </span>
          </button>

          <span *ngIf="userData && loaded"
                class="mdc-top-app-bar__title">
            <a href="/">
              <img class="image-size"
                   src="../../assets/Nuage-Logo.png"
                   title="Nuage">
            </a>
          </span>
        </section>

        <a *ngIf="noUserData && currentUrl !== '/login'"

           class="gotologin-button"
           color="warn"

           mat-flat-button
           (click)="goToLogin()">
          Go to login page
        </a>

        <section *ngIf="userEnabled"
                 [ngClass]="['mdc-top-app-bar__section', 'mdc-top-app-bar__section--align-end']">
          <div *ngIf="userData"
               class="top-bar-user-info">
            <span class="top-bar-user-name">
              {{userData.userName}}
            </span>
            <span class="top-bar-user-meta">
              {{ userData.userDBRole === 'CLIENT_ADMIN' ? 'Facilitator' : userData.userDBRole }}
              <ng-container *ngIf="userData.facility">
                · {{ facilityName || userData.facility }}
              </ng-container>
            </span>
          </div>
          <a class="top-bar-logout"
             (click)="auth_$.logout()">
            <mat-icon aria-hidden="true">
              power_settings_new
            </mat-icon>
            <span>
              Logout
            </span>
          </a>
        </section>
      </div>
    </header>
    <div class="mdc-top-app-bar--fixed-adjust">
      <div>
        <router-outlet></router-outlet>
      </div>
      <div class="footer fx-col"></div>
      <app-footer></app-footer>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
